<template>
  <div class="ping-castle-wrapper">
    <div class="empty-box-slot">
    </div>
    <div class="ping-castle-products-select"
    :class="{error: error}">
      <div class="products-list-wrapper">

        <div class="product-list-item"
             v-for="(productOption, index) in pingCastleProducts"
             :key="index">
          <div class="item-checkbox">
            <input
              type="checkbox"
              :value="productOption.prodCode"
              v-model="localSelected"
            />
          </div>
          <div class="item-data">
            <div class="item-product-title">
              <img :src="productOption.iconSrc"
                   :alt="productOption.imageAlt">
              <p>
                {{ productOption.prodName }}
                <span
                  v-if="productOption.prodFormerlyName"
                > ({{ productOption.prodFormerlyName }})
                </span>
              </p>
            </div>
            <div class="item-product-link">
              <a target="_blank" :href="'/'+productOption.prodLink">Learn More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'NwxAppPingCastleProductsSelect',
    props: {
      items: {
        type: Array,
      },
      selected: {
        type: [String, Array],
        default: undefined,
      },
      error: Boolean,
    },
    model: {
      prop: 'selected',
      event: 'appselect:changed',
    },
    data() {
      return {
        localSelected: [],
        pingCastleProducts: [],
      };
    },
    watch: {
      selected(selected) {
        // eslint-disable-next-line vue/no-mutating-props
        this.selected = selected;
      },
      localSelected(selected) {
        this.$emit('appselect:changed', selected);
      },
    },
    created() {
      this.pingCastleProducts = this.items;
    },
  };
</script>
<style lang="less" scoped>
@import "../assets/variables";

.ping-castle-wrapper{
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 22px;
}
.empty-box-slot{
  width: 100%;
  box-sizing: content-box;
}
.ping-castle-products-select{
  width: 100%;
  border: 1px solid @mainBlue;
  border-radius: 0px 0px 5px 5px;
  box-sizing: content-box;
  &.error{
    border-color: @mainRed;
  }

  .products-list-wrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 45px;
    margin: 43px 30px 50px 30px;

    .product-list-item{
      display: flex;
      gap: 16px;

      .item-checkbox{
        accent-color: #0068da;
        width: 16px;
        height: 16px;
        margin: 0;
        position: relative;
        top: 2px;

        input{
          width: 16px;
          height: 16px;
          margin: 0;
        }
      }

      .item-data{

        .item-product-title{
          display: flex;
          gap: 10px;
          margin-bottom: 15px;

          img{
            width: 20px;
            height: 20px;
          }
          p{
            margin: 0;
            font-family: Open Sans;
            font-size: 15px;
            font-weight: 600;

            ::v-deep span{
              font-family: Open Sans;
              font-size: 15px;
              font-weight: 600;
              color: #8B96A3;
            }
          }
        }
        .item-product-text{
          font-family: Open Sans;
          font-size: 15px;
          font-weight: 400;
          line-height: 19.5px;
          margin-bottom: 16px;
        }
        .item-product-link{
          a{
            font-family: Open Sans;
            font-size: 15px;
            font-weight: 600;
            line-height: 28px;
            color: #0068DA;
            text-decoration: underline !important;

            &:hover {
              color: #0047bb;
            }
          }
        }
      }
    }
  }

}
</style>
